var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkIconUia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3504 8.00002C15.3504 3.94073 12.0597 0.650024 8.00039 0.650024C3.9411 0.650024 0.650391 3.94073 0.650391 8.00002C0.650391 12.0593 3.9411 15.35 8.00039 15.35C12.0597 15.35 15.3504 12.0593 15.3504 8.00002Z",
    stroke: "#777777",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00684,
    cy: 11.8916,
    r: 0.75,
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75879 6.22771C5.75867 5.03379 6.5639 3.86765 8.14653 3.86764C9.72917 3.86762 10.7478 5.44575 9.97906 6.92183C9.28492 8.25457 7.97994 8.64263 7.97994 10.1426",
    stroke: "#777777",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIconUia);
export default __webpack_public_path__ + "static/media/Question_Mark_Icon_UIA.ff7419fdac00ade2f76e4ac63e84ef07.svg";
export { ForwardRef as ReactComponent };